// extracted by mini-css-extract-plugin
export default {"colorCircle":"ColorInput_colorCircle__Voig9"};